<template>
  <div class="multi-tabs">
    <div
      class="header"
      :class="{'sub-header': subTab}"
    >
      <a
        v-for="tab in tabs"
        :key="tab.Title"
        class="tab"
        :class="{'selected': isSelected(tab.Title)}"
        @click="selectTab(tab)"
      >
        {{ tab.Title }}
      </a>
    </div>
    <multi-tabs
      v-if="hasSubTabs"
      :tabs="selectedTab.SubsidiaryItem"
      :sub-tab="true"
    />
    <div v-else>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div
              class="col-12"
            >
              {{ selectedTab.Description }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="selectedTab.LinkLeft || selectedTab.LinkRight"
        class="link-bar"
      >
        <div class="container">
          <div class="row">
            <div class="col-12">
              <a
                :href="selectedTab.LinkLeft"
                class="button"
              >{{ selectedTab.DescriptionLinkLeft }}</a>
              <a
                :href="selectedTab.LinkRight"
                class="button"
              >{{ selectedTab.DescriptionLinkRight }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref, computed, onMounted, watch
} from 'vue'

export default {
  name: 'multi-tabs',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    subTab: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const selectedTab = ref({
      Title: '',
      Description: null,
      LinkLeft: null,
      LinkRight: null,
      SubsidiaryItem: []
    })

    const hasSubTabs = computed(() => {
      return selectedTab.value.SubsidiaryItem && selectedTab.value.SubsidiaryItem.length > 0
    })

    const selectTab = (tab) => {
      const [firstTab] = props.tabs
      selectedTab.value = tab || firstTab
    }

    const selectTabByName = (tabTitle) => {
      selectTab(props.tabs.find(tab => tab.Title === tabTitle))
    }

    const isSelected = (title) => {
      return selectedTab.value.Title === title
    }

    const initialSelection = () => {
      const uri = window.location.search.substring(1)
      const params = new URLSearchParams(uri)
      const preSelect = params.get('s')
      selectTabByName(preSelect)
    }

    onMounted(() => {
      initialSelection()
    })

    watch(() => props.tabs, () => {
      initialSelection()
    })

    return {
      selectedTab,
      hasSubTabs,
      selectTab,
      isSelected
    }
  }
}
</script>
